// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();
//       this.form = this.querySelector('form');
//       this.form.querySelector('[name="id"]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-items');
//       this.submitButton = this.querySelector('[type="submit"]');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
//       this.hideErrors = this.dataset.hideErrors === 'true';
//       }
//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       // evt.stopPropagation();
//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
//       this.handleErrorMessage();
//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];
//       const formData = new FormData(this.form);
//       if (this.cart) {
//         formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
//         formData.append('sections_url', window.location.pathname);
//         this.cart.setActiveElement(document.activeElement);
//       }
//       config.body = formData;
//      fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
//               productVariantId: formData.get('id'),
//               errors: response.errors || response.description,
//               message: response.message
//             }}));
//             this.handleErrorMessage(response.description);
//             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//             if (!soldOutMessage) return;
//             this.submitButton.setAttribute('aria-disabled', true);
//             this.submitButton.querySelector('span').classList.add('hidden');
//             soldOutMessage.classList.remove('hidden');
//             this.error = true;
//             return;
//           } else if (!this.cart) {
//             window.location = window.routes.cart_url;
//             return;
//           }
//           if(!this.error) {
//             this.error = false;
//             // pushSuccessMessage(window.cartStrings.success);
//             const quickAddDrawer = this.closest('quick-add-drawer');
//             if (quickAddDrawer) {
//               document.body.addEventListener('drawerClosed', () => {
//                 setTimeout(() => { this.cart.renderContents(response) });
//               }, { once: true });
//               quickAddDrawer.close();
//             } else {
//               this.cart.renderContents(response);
//             }
//             document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {productVariantId: formData.get('id')}}));
//           }
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//         });
//     }
//   handleErrorMessage(errorMessage = false) {
//       if (this.hideErrors) return;
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       if(errorMessage && !this.errorMessageWrapper) {
//         pushErrorMessage(errorMessage);
//       }
//       if (!this.errorMessageWrapper) return;
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
//     if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
//   }

// old
// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();
//       this.form = this.querySelector('form');
//       this.form.querySelector('[name="id"]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-items');
//       this.submitButton = this.querySelector('[type="submit"]');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
//       this.hideErrors = this.dataset.hideErrors === 'true';
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
//       this.handleErrorMessage();
//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];
//       const formData = new FormData(this.form);

//       if (this.cart) {
//         formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
//         formData.append('sections_url', window.location.pathname);
//         this.cart.setActiveElement(document.activeElement);
//       }

//       config.body = formData;

//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             // Handle error if status indicates failure
//             document.dispatchEvent(new CustomEvent('afterAddCartError', { detail: {
//               productVariantId: formData.get('id'),
//               errors: response.errors || response.description,
//               message: response.message
//             }}));
//             this.handleErrorMessage(response.description);

//             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//             if (!soldOutMessage) return;
//             this.submitButton.setAttribute('aria-disabled', true);
//             this.submitButton.querySelector('span').classList.add('hidden');
//             soldOutMessage.classList.remove('hidden');
//             this.error = true;
//             return;
//           } else {
//             // Only navigate to the cart page if there is no error
//             if (!this.error && this.cart) {
//               window.location = window.routes.cart_url;
//             }
//             if (!this.cart) return; // Don't process further if no cart

//             // Handle successful cart addition
//             if (!this.error) {
//               this.error = false;
//               const quickAddDrawer = this.closest('quick-add-drawer');
//               if (quickAddDrawer) {
//                 document.body.addEventListener('drawerClosed', () => {
//                   setTimeout(() => { this.cart.renderContents(response); });
//                 }, { once: true });
//                 quickAddDrawer.close();
//               } else {
//                 this.cart.renderContents(response);
//               }
//               document.dispatchEvent(new CustomEvent('afterCartChanged', { detail: { productVariantId: formData.get('id') }}));
//             }
//           }
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       if (this.hideErrors) return;
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       if (errorMessage && !this.errorMessageWrapper) {
//         pushErrorMessage(errorMessage);
//       }
//       if (!this.errorMessageWrapper) return;
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }



// new

// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       this.form.querySelector('[name="id"]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-items');
//       this.submitButton = this.querySelector('[type="submit"]');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
//       this.hideErrors = this.dataset.hideErrors === 'true';
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//        console.log('Product form submitted');
//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//       this.handleErrorMessage();
//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//       const formData = new FormData(this.form);
//       if (this.cart) {
//         formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
//         formData.append('sections_url', window.location.pathname);
//         this.cart.setActiveElement(document.activeElement);
//       }
//       config.body = formData;

//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
//               productVariantId: formData.get('id'),
//               errors: response.errors || response.description,
//               message: response.message
//             }}));
//             this.handleErrorMessage(response.description);
//             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//             if (!soldOutMessage) return;
//             this.submitButton.setAttribute('aria-disabled', true);
//             this.submitButton.querySelector('span').classList.add('hidden');
//             soldOutMessage.classList.remove('hidden');
//             this.error = true;
//             return;
//           } else if (!this.cart) {
//             window.location = window.routes.cart_url;
//             return;
//           }
          
//           if(!this.error) {
//             this.error = false;
//             // pushSuccessMessage(window.cartStrings.success);
            
//             const quickAddDrawer = this.closest('quick-add-drawer');
//             if (quickAddDrawer) {
//               document.body.addEventListener('drawerClosed', () => {
//                 setTimeout(() => { this.cart.renderContents(response) });
//               }, { once: true });
//               quickAddDrawer.close();
//             } else {
//               this.cart.renderContents(response);
              
//             }
//             document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {productVariantId: formData.get('id')}}));
//           }
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       if (this.hideErrors) return;
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       if(errorMessage && !this.errorMessageWrapper) {
//         pushErrorMessage(errorMessage);
//       }
//       if (!this.errorMessageWrapper) return;
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name="id"]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-items');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }
      onSubmitHandler(evt) {
      evt.preventDefault();
      
if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
     
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
// Function to check cookie
function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
}
fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message
            }}));
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if(!this.error) {
    this.error = false;

    // ===== HEADER BUBBLE COUNT UPDATE START =====
    const cartCountBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    const cartVisuallyHidden = document.querySelector('.cart-count-bubble span.visually-hidden');
    if (cartCountBubble && response?.cart?.item_count !== undefined) {
      cartCountBubble.textContent = response.cart.item_count;
    }
    if (cartVisuallyHidden && response?.cart?.item_count !== undefined) {
      cartVisuallyHidden.textContent = `${response.cart.item_count} items`;
    }
    // ===== HEADER BUBBLE COUNT UPDATE END =====
    
    // pushSuccessMessage(window.cartStrings.success);
    const quickAddDrawer = this.closest('quick-add-drawer');
    
// The old trade-not-select cookie must not bypass this session's introduction.
    // CartDrawer.renderContents decides whether to show the optional trade-in
    // prompt or continue to the actual cart page.
// Normal drawer behavior if cookie not set
    if (quickAddDrawer) {
        document.body.addEventListener('drawerClosed', () => {
            setTimeout(() => { 
                this.cart.renderContents(response); // Only render if cookie not set
            });
        }, { once: true });
        quickAddDrawer.close();
    } else {
        this.cart.renderContents(response); // Only render if cookie not set
    }
document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {productVariantId: formData.get('id')}}));
}
})
.catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }


handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if(errorMessage && !this.errorMessageWrapper) {
        pushErrorMessage(errorMessage);
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// ===== HEADER BUBBLE COUNT INITIALIZATION ON PAGE LOAD START =====
function updateCartBubble(count) {
  const cartCountBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
  const cartVisuallyHidden = document.querySelector('.cart-count-bubble span.visually-hidden');
  if (cartCountBubble) cartCountBubble.textContent = count;
  if (cartVisuallyHidden) cartVisuallyHidden.textContent = `${count} items`;
}

function initCartBubble() {
  // Wait until header bubble element exists
  const cartBubbleExists = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
  if (!cartBubbleExists) {
    setTimeout(initCartBubble, 100); // retry after 100ms
    return;
  }

  // Fetch current cart data
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // Use actual item_count from cart, even if items already exist
      updateCartBubble(cart.item_count);
    })
    .catch(console.error);
}

// Run on every page load
document.addEventListener('DOMContentLoaded', initCartBubble);
// ===== HEADER BUBBLE COUNT INITIALIZATION ON PAGE LOAD END =====



